import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import { configureChart, generateSeries } from '@app/widgets/helpers/widget-helpers';

export const WhakaaweWhenuaPohuenui: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Pohuenui',
  generateSeries(['nrc_north_at_applecross_rd'], ['flow', 'relative-water-level-mm'])
);

export const PanoniAhuroaAwa: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Ahuroa Awa',
  generateSeries(['nrc_327283'], ['dissolved-oxygen-mg-per-litre', 'water-temperature'])
);

export const UaPoupouwhenuaMahingaMataitai: BasicCartesianChartConfig = configureChart(
  'UA - Rainfall and Relative Water Level: Poupouwhenua Mahinga Mātaitai',
  generateSeries(['nrc_whangarei_harbour_at_marsden_point'], ['relative-water-level-mm']).concat(
    generateSeries(['nrc_whangarei_harbour_at_marsden_point_oil_refinery'], ['precipitation'])
  )
);

export const PanoniRuakakaEstuaryMahingaMataitai: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Ruakākā Estuary Mahinga Mātaitai',
  generateSeries(['nrc_ruakaka_at_fosters'], ['precipitation']).concat(
    generateSeries(
      ['nrc_ruakaka_at_flyger_rd'],
      ['turbidity-fnu', 'dissolved-oxygen-mg-per-litre', 'relative-water-level-mm', 'water-temperature', 'flow']
    )
  )
);

export const PanoniTakahiwaiMahingaMataitai: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Takahiwai Mahinga Mātaitai',
  generateSeries(['nrc_otaika_at_cemetery_road'], ['precipitation']).concat(
    generateSeries(
      ['nrc_otaika_at_kay'],
      ['turbidity-fnu', 'dissolved-oxygen-mg-per-litre', 'relative-water-level-mm', 'water-temperature']
    )
  )
);

export const UaWaipuAwa: BasicCartesianChartConfig = configureChart(
  'UA - Rainfall and Flow Rate: Waipū Awa',
  generateSeries(['nrc_waihoihoi_at_st_marys_rd'], ['flow', 'precipitation']).concat(
    generateSeries(['nrc_waihoihoi_at_brynderwyn'], ['precipitation'])
  )
);

export const RainfallWilsonsDam: BasicCartesianChartConfig = configureChart(
  'Wilsons Dam Rainfall',
  generateSeries(['nrc_waiwarawara_at_wilsons_dam'], ['precipitation'])
);

export const RainfallOtaika: BasicCartesianChartConfig = configureChart(
  'Otaika Rainfall',
  generateSeries(['nrc_otaika_at_cemetery_road'], ['precipitation'])
);
